import { SyncLoader } from 'react-spinners'
import React, { Fragment } from 'react'

import Center from './Center'
import LazyAction from './LazyAction'
import { COLORS } from '@btime/constants'

const LoadMoreOnBottom = ({ children, loadingMore, canLoadMore, loadMoreAction }) => (
  <Fragment>
    {children}
    <LazyAction action={loadMoreAction} waiting={loadingMore} disabled={!canLoadMore}>
      <Center>
        <SyncLoader color={COLORS.blue} size={8} />
      </Center>
    </LazyAction>
  </Fragment>
)

export default LoadMoreOnBottom
